/* tslint:disable */

declare var Object: any;
export interface JobPrescreenInterface {
  "sfdcId"?: string;
  "Answer__c"?: string;
  "Answer_ID__c"?: string;
  "Answer_Txt__c"?: string;
  "Application__c"?: string;
  "Business_Unit__c"?: string;
  "Originating_Prescreen__c"?: string;
  "Question__c"?: string;
  "Question_ID__c"?: string;
  "Question_Set__c"?: string;
  "Question_Size__c"?: string;
  "Rich_Text_Question__c"?: string;
  "Rollover__c"?: boolean;
  "Score__c"?: number;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class JobPrescreen implements JobPrescreenInterface {
  "sfdcId": string;
  "Answer__c": string;
  "Answer_ID__c": string;
  "Answer_Txt__c": string;
  "Application__c": string;
  "Business_Unit__c": string;
  "Originating_Prescreen__c": string;
  "Question__c": string;
  "Question_ID__c": string;
  "Question_Set__c": string;
  "Question_Size__c": string;
  "Rich_Text_Question__c": string;
  "Rollover__c": boolean;
  "Score__c": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: JobPrescreenInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `JobPrescreen`.
   */
  public static getModelName() {
    return "JobPrescreen";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of JobPrescreen for dynamic purposes.
  **/
  public static factory(data: JobPrescreenInterface): JobPrescreen{
    return new JobPrescreen(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'JobPrescreen',
      plural: 'JobPrescreens',
      path: 'JobPrescreens',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Answer__c": {
          name: 'Answer__c',
          type: 'string'
        },
        "Answer_ID__c": {
          name: 'Answer_ID__c',
          type: 'string'
        },
        "Answer_Txt__c": {
          name: 'Answer_Txt__c',
          type: 'string'
        },
        "Application__c": {
          name: 'Application__c',
          type: 'string'
        },
        "Business_Unit__c": {
          name: 'Business_Unit__c',
          type: 'string'
        },
        "Originating_Prescreen__c": {
          name: 'Originating_Prescreen__c',
          type: 'string'
        },
        "Question__c": {
          name: 'Question__c',
          type: 'string'
        },
        "Question_ID__c": {
          name: 'Question_ID__c',
          type: 'string'
        },
        "Question_Set__c": {
          name: 'Question_Set__c',
          type: 'string'
        },
        "Question_Size__c": {
          name: 'Question_Size__c',
          type: 'string'
        },
        "Rich_Text_Question__c": {
          name: 'Rich_Text_Question__c',
          type: 'string'
        },
        "Rollover__c": {
          name: 'Rollover__c',
          type: 'boolean'
        },
        "Score__c": {
          name: 'Score__c',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
